<script>
import Vue from 'vue';

export default {
  name: 'order-tax-number-checker',
  methods: {
    verifyCustomerTaxID (countryPrefix, taxNumber, customerCountryID, countries, successAction, nextCallback = false) {
      let nonVerifiedCountries = countries.filter(country => country.verify_tax_number === 0);
      let nonVerifiedCountryPrefixes = nonVerifiedCountries.map(country => country.code);
      let nonVerifiedCountryIDs = nonVerifiedCountries.map(country => country.id);

      if (nonVerifiedCountryIDs.indexOf(customerCountryID) === -1 && !countryPrefix) {
        Vue.swal({
          title: this.$t('customer.youMustSelectCountryPrefix'),
          html: this.$t('customer.youMustSelectCountryPrefixDesc2'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });

        return;
      }

      if (nonVerifiedCountryIDs.indexOf(customerCountryID) > -1 || nonVerifiedCountryPrefixes.indexOf(countryPrefix) > -1) {
        successAction(nextCallback);
        return;
      }

      this.taxNumberCheckInProgress = true;

      this.$http.get('/customers/verify-tax-number', {
        params: {
          id: 0,
          prefix: countryPrefix,
          number: taxNumber
        }
      }).then(response => {
        if (response.data.verification && response.data.verification.is_exception) {
          Vue.swal({
            title: this.$t('ui.errorOccured'),
            html: this.$t('customer.viesCommunicationIssue'),
            type: 'error',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true
          }).then(() => {
            successAction(nextCallback);
          });

          this.taxNumberCheckInProgress = false;
        } else if (response.data.success) {
          if (response.data.verification_skipped === 1 || (response.data.verification.status === 'VALID' && response.data.verification.is_active)) {
            this.taxNumberCheckInProgress = false;
            successAction(nextCallback);
            return;
          }

          if (response.data.integration_disabled === 1) {
            Vue.swal({
              title: this.$t('customer.verificationIntegrationDisabledTitle'),
              html: this.$t('customer.verificationIntegrationDisabledDesc'),
              type: 'warning',
              confirmButtonText: this.$t('ui.ok'),
              buttonsStyling: true
            }).then(() => {
              successAction(nextCallback);
            });

            this.taxNumberCheckInProgress = false;
            return;
          } else if (response.data.verification_skipped !== 1) {
            if (response.data.verification.status !== 'VALID') {
              Vue.swal({
                title: this.$t('ui.errorOccured'),
                html: this.$t('customer.invalidTaxNumberLong2'),
                type: 'warning',
                confirmButtonText: this.$t('ui.ok'),
                buttonsStyling: true
              });
            } else if (!response.data.verification.is_active) {
              Vue.swal({
                title: this.$t('ui.errorOccured'),
                html: this.$t('customer.inactiveTaxNumberLong'),
                type: 'warning',
                confirmButtonText: this.$t('ui.ok'),
                buttonsStyling: true
              });
            }
          }

          this.taxNumberCheckInProgress = false;
        } else {
          Vue.swal({
            title: this.$t('ui.errorOccured'),
            html: this.$t('ui.tryAgain'),
            type: 'warning',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true
          });

          this.taxNumberCheckInProgress = false;
        }
      }).catch(error => {
        console.log(error);

        if (error.response && error.response.data.errors && error.response.data.errors.number) {
          Vue.swal({
            title: this.$t('ui.errorOccured'),
            html: this.$t('customer.invalidTaxNumberLong2'),
            type: 'warning',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true
          });
        } else {
          Vue.swal({
            title: this.$t('ui.errorOccured'),
            html: this.$t('ui.tryAgain'),
            type: 'warning',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true
          });
        }

        this.taxNumberCheckInProgress = false;
      });
    }
  }
}
</script>
